/**
 * Customer Deleted List Configuration
 */
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import {
    createDateFormatter,
    createInternalLinkFormatter,
    createOptionsFormatter,
} from '@/components/ui/data-table-customized'
import type { DeletedCustomer } from '@/modules/Customer/types'
import { CUSTOMER_STATUS_OPTIONS } from '@/modules/MailerCampaign/types'
import type { TFunction } from 'i18next'

export const getDeletedColumns = (
    t: TFunction
): DataTableColumn<DeletedCustomer>[] => [
    {
        key: 'customer_id',
        title: 'ID',
        width: 300,
        pinned: 'left',
        cellClassName: 'uppercase truncate',
        formatter: createInternalLinkFormatter({
            pathKey: 'customerDetail',
            pathParams: (_, row) => ({ id: String(row.customer_id) }),
            label: (_, row) =>
                [row.customer_id, row?.company_name || row?.customer_name]
                    .filter(Boolean)
                    .join(' - '),
        }),
    },
    {
        key: 'customer_email',
        title: t('customer_email'),
        width: 250,
        cellClassName: 'italic text-gray-500 line-through', // gạch ngang
    },
    {
        key: 'customer_status',
        title: t('customer_status'),
        width: 150,
        formatter: createOptionsFormatter({
            options: CUSTOMER_STATUS_OPTIONS(t),
        }),
    },
    {
        key: 'deletion_reason',
        title: t('deletion_reason'),
        width: 300,
        render: (value) => (
            <span className="line-clamp-2" title={value || ''}>
                {value || '-'}
            </span>
        ),
    },
    {
        key: 'deleted_by_name',
        title: t('deleted_by'),
        width: 150,
    },
    {
        key: 'deleted_at',
        title: t('deleted_at'),
        width: 150,
        sortable: true,
        formatter: createDateFormatter({ format: 'DD/MM/YYYY HH:mm' }),
    },
]

export const DELETED_FILTER_DEFAULTS = {
    q: '',
}

// ============================================================================
// Sort Configuration
// ============================================================================

export const DELETED_SORT_CONFIG = {
    defaultSort: {
        sort_by: 'deleted_at',
        sort_order: 'desc' as const,
    },
    sortableFields: ['deleted_at', 'customer_name'],
}
